import gql from 'graphql-tag'

export const GET_ORDER_SUMPRICE = gql`
  query {
    orderGroups {
      orderGroupBy {
        shopId {
          sum {
            price
          }
        }
      }
    }
  }
`

export default {
  GET_ORDER_SUMPRICE
}
